import React, { useEffect, useState } from "react";
import { Link, useNavigate, useParams, useSearchParams } from "react-router-dom";
import styles from "../../components/DashBoard/Header.module.css";
import SlideUpWrapper from "../../components/Transitions/SlideUpWrapper";
import { Icon } from "react-icons-kit"
import { creditCard } from 'react-icons-kit/fa/creditCard';
import { bank } from 'react-icons-kit/fa/bank';
import { gift } from 'react-icons-kit/fa/gift';
import API from "../../ApiConfig";
import { GET_OFFERS_VIA_PACKAGE_TYPE, TRACK_OFFER_CLICK, TRACK_SCROLL } from "../../Utils/constant";
import cogoToast from "cogo-toast-react-17-fix";
import { getDeviceType } from "../../Utils/UserInfo";
const colors = ["#fff3cd", "#d1e7dd", "#cfe2ff", "#f8d7da", "#e2e3e5"]
const randomColor = colors[Math.floor(Math.random() * colors.length)]
const AuthNumberOfferPage = () => {
  const userAgent=navigator.userAgent

  const  deviceType=getDeviceType()
  const[data, setData]=useState("")

  const navigate=useNavigate();
  const {user_uuid, client_code, package_type}=useParams()

  console.log(user_uuid);
                                                                                                                                                                                                                                           
  const [rewards,setRewards] = useState([]);


  useEffect(()=>{
    window.scrollTo({ top: 0, behavior: "smooth" })
    FetchOffers()
  },[])
  const FetchOffers=()=>{
    API.get(`${GET_OFFERS_VIA_PACKAGE_TYPE}${package_type}/${user_uuid}`,{
      params:{
        client_code:client_code,
        device_type:deviceType,
        user_type:1
      }
    })
    .then(res=>{
      // debugger
      setRewards(res.data.data.offers)
      setData(res.data.data)

      
    })
    .catch(err=>{
      cogoToast.error(err.response.data.detail)
    })
  }
  const handleOfferClick=(offerData)=>{


    const apiData={
      session_id:data.session_id,
      user_uuid:user_uuid,
      client_code:client_code,
      offer_id:offerData.id,
      deviceType:deviceType
    }

    API.post(TRACK_OFFER_CLICK,apiData)
    .then(res=>{
      if(res.status==200){
        return
      }
      
    })
    .catch(err=>{

      cogoToast.error(err.response.data.detail[0])
    })

  }
  const handleWebScroll=()=>{
    const apiData={
        session_id:data.session_id,
        user_uuid:user_uuid,
        client_code:client_code,
        deviceType:deviceType
    }
    API.post(TRACK_SCROLL,apiData)
    .then(res=>{
      if(res.status==200){
        return
      }
      
    })
    .catch(err=>{

      cogoToast.error(err.response.data.detail[0])
    })
  }
  const handleScroll=()=>{
    handleWebScroll()
  }
  // useEffect(() => {
  //   // Add scroll listener
  //   window.addEventListener("scroll", handleScroll);

  //   return () => {
  //     window.removeEventListener("scroll", handleScroll);
  //   };
  // }, [])
  console.log(rewards);
  
  return (

    <SlideUpWrapper>
    <body className="bg-gray-50 text-gray-900 font-sans">
      <header className={styles.headerStyle}>
        <div className={styles.hEADERTITLE}>
          <div className={styles.authnumberLogo} onClick={()=>{navigate("/dashboard")}}>
            <div className={styles.authnumberParent}>
              <img
                className={styles.authnumberIcon}
                loading="eager"
                alt=""
                src="/authnumber_1.svg"
              />
              <img
                className={styles.subtractIcon}
                loading="eager"
                alt=""
                src="/Header_icon.svg"
              />
            </div>
          </div>
          {/* <div>
            <div>
              <Link
                to={"/app/login"}
                className="text-xl text-gray-700 no-underline hover:text-blue-600 px-3 no-underline"
              >
                Login
              </Link>
            </div>
          </div> */}
        </div>
      </header>

      <section className="bg-blue-50" style={{ padding: "7rem 0px 3rem 0px" }}>
        <div className="max-w-4xl mx-auto text-center">
          <h2 className="text-3xl font-bold text-blue-700">
            Exclusive Offers for You
          </h2>
          <p className="mt-2 text-gray-600 text-xl">
            Browse personalized offers from our trusted partners. Select one to
            continue.
          </p>
        </div>
      </section>
      <main className="max-w-6xl mx-auto px-4 py-10">
        <div className="grid gap-6 sm:grid-cols-2 lg:grid-cols-3">
          {rewards&&rewards.length>0?rewards.map((i, index) => (
            <div
            key={index}
              className="bg-white rounded-2xl shadow hover:shadow-lg transition cursor-pointer p-2"
              style={{backgroundColor:colors[randomColor % colors.length]}}
            >
              <div className="p-6 flex flex-col" style={{ height: "90%" }}>
                <img
                  src={i?.icon_url}
                  alt="Logo"
                  className="h-12 object-contain mb-2"
                />
                <h3 className="text-lg font-semibold">{i?.title}</h3>
                <p className="text-sm text-gray-600 mt-2 flex-grow">
                  {i?.description}
                </p>
                <div className="mt-2 flex items-center justify-between">
                  <span className="text-blue-600 font-bold">{i?.reward}</span>
                  <a
                    href={i?.affiliate_link}
                    target="_blank"
                    rel="noopener noreferrer"
                    className="px-4 py-2 bg-blue-600 text-white rounded-xl text-sm hover:bg-blue-700 no-underline"
                    onClick={(e)=>handleOfferClick(i)}
                  >
                    View Offer
                  </a>
                </div>
              </div>
            </div>
          )):"No Rewards Found"}
        </div>
      </main>
    </body>
    </SlideUpWrapper>
  );
};

export default AuthNumberOfferPage;
